import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { BaseStyle } from 'modules/Core/Common/Links/Base.styles';

const RouterLink = styled((props) => <Link {...props} />)`
  ${BaseStyle}
`;

export { RouterLink };
